import { render, staticRenderFns } from "./BackTo.vue?vue&type=template&id=1d1d8ded&"
import script from "./BackTo.vue?vue&type=script&lang=js&"
export * from "./BackTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports